import * as React from 'react';
import {FunctionComponent, useEffect, useState} from 'react';
import * as ReactDOM from 'react-dom';
import {io} from 'socket.io-client';

interface OwnProps {
    entryId: number;
}

enum Status {
    Idle,
    Requesting,
    Downloading,
    Timeout,
}

interface IdleState {
    status: Status.Idle;
}

interface WaitingState {
    status: Status.Requesting;
    startedAt: Date;
}
interface DownloadingState {
    status: Status.Downloading;
    url: string;
}
interface TimeoutState {
    status: Status.Timeout;
}

type State = IdleState | WaitingState | DownloadingState | TimeoutState;

export const ExportEntryButton: FunctionComponent<OwnProps> = ({entryId}) => {
    const [state, setState] = useState<State>({status: Status.Idle});

    function request() {
        setState({status: Status.Requesting, startedAt: new Date()});

        const socket = io((process as any).env.MIX_NOHRD_ECHO_CLIENT_URL);

        const timeout = setTimeout(() => {
            socket.close();
            setState({
                status: Status.Timeout,
            });
        }, 30000);

        socket.on(`exports.tcx.${entryId}`, (payload) => {
            clearTimeout(timeout);
            socket.close();
            if (payload.url) {
                setState({
                    status: Status.Downloading,
                    url: payload.url,
                });
                window.location.href = payload.url;
            }
        });
        socket.on('connect', async () => {
            await fetch(`/ajax/entries/${entryId}/export/tcx`, {
                method: 'POST',
                headers: {
                    'X-Csrf-Token': (document as any).head.querySelector('meta[name="csrf-token"]').content,
                    'X-Socket-Id': socket.id,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
        });
    }

    switch (state.status) {
        case Status.Idle:
            return (
                <button className="btn btn-primary pull-right" onClick={() => request()}>
                    Download
                </button>
            );
        case Status.Requesting:
            return (
                <button className="btn btn-primary pull-right" disabled>
                    Generating...
                </button>
            );
        case Status.Downloading:
            return (
                <a className="btn btn-primary pull-right" href={state.url} download={state.url}>
                    Downloading
                </a>
            );
        case Status.Timeout:
            return (
                <button className="btn btn-primary pull-right" onClick={() => request()}>
                    Try again
                </button>
            );
    }
};

Array.from(document.getElementsByClassName('export-entry')).forEach((element) => {
    const entryIdAttribute: string | null = element.getAttribute('data-entry-id');
    if (entryIdAttribute) {
        ReactDOM.render(<ExportEntryButton entryId={parseInt(entryIdAttribute, 10)} />, element);
    }
});
